import type { VoidFunctionComponent } from 'react';

import { plural } from '../../../../shared/helpers';
import { isProjectScope, isReleaseGroupScope } from '../../../../shared/issuesV2';
import { Icon, icons } from '../../generic/Icon';
import { ICON_SIZE } from '../../generic/Icon/icon-constants';
import type { ProjectScope, ReleaseGroupScope } from '../../../../shared/issuesV2';

import styles from './IssueComparison.module.less';

type Props = {
  scope: ProjectScope | ReleaseGroupScope;
};

const EmptyState: VoidFunctionComponent<Props> = ({ scope }) => {
  const isProject = isProjectScope(scope);
  const isReleaseGroup = isReleaseGroupScope(scope);

  let comparisonType = 'item';
  if (isProject) {
    comparisonType = 'revision';
  } else if (isReleaseGroup) {
    comparisonType = 'release';
  }

  return (
    <div className={styles.emptyStateContainer}>
      <span className={styles.imageContainer}>
        <Icon icon={icons.codeCompare} size={ICON_SIZE.XXL} />
      </span>
      <div className={styles.mainText}>
        Compare changes across {plural(2, comparisonType)}
      </div>
      <div className={styles.subText}>
        Select a {plural(1, comparisonType)} above so you can see which issues are new, remediated, or unchanged.
      </div>
    </div>
  );
};

export default EmptyState;
